<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="args['item.no']" clearable placeholder="placeholder.pleaseEnterItemNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="args['item.name']" clearable placeholder="placeholder.pleaseEnterItemName" @clear="refresh()" @keydown.native.enter="refresh()"/>
        <vxe-input v-model="args['lot.no']" clearable placeholder="placeholder.pleaseEnterLotNo" @clear="refresh()" @keydown.native.enter="refresh()"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh()"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.packageNumber"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
        <vxe-column field="lot.no" title="business.label.lot"/>
        <vxe-column field="location.no" title="business.label.location"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="command.actualQuantity" title="business.label.quantity"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.scanSupervisorCode" icon="vxe-icon-check" status="primary" @click.stop="supervise(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <supervised-modal ref="supervisedModal" @success="refresh()"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import SupervisedModal from '@/views/modal/SupervisedModal.vue'

export default {
  name: 'ReviewDetail',
  components: { SupervisedModal },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 15,
      contentSize: 0,
      orderId: null,
      args: {
        original: true,
        'item.no': '',
        'item.name': '',
        'lot.no': ''
      }
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      if (!this.orderId) {
        return this.$message.warning('请选择一行单据再查询明细信息')
      }
      this.loading = true
      const args = {
        ...this.args,
        'order.id': this.orderId
      }
      findAll('shipmentCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(id) {
      if (id) this.orderId = id
      this.page = 1
      this.fetch()
    },
    reset() {
      this.args['item.no'] = ''
      this.args['item.name'] = ''
      this.args['lot.no'] = ''
      this.refresh()
    },
    clear() {
      this.data = []
    },
    supervise(row) {
      this.$refs.supervisedModal.open({ 'command.ids': [row.command.id] })
    }
  }
}
</script>